/**
 * #122 / #124: One cash-locking open order in the "PSTX Open Orders" hold bucket.
 *
 * Mirrors the per-order item returned by
 *   GET Api/v1/MySec/{role}/wallets/heldOpenOrders
 * where `{role}` resolves to individualInvestor / companyRep via the HTTP interceptor.
 *
 * `action`: 1 = Buy, 2 = Sell (WalletTransactionEvent BuyShares / SellShares).
 * `heldAmount` is the per-order locked cash; the list already reconciles to
 * `openOrdersHoldAmount` server-side, so render — do not re-sum-and-diverge.
 */
export interface HeldOpenOrderModel {
  tickerCode: string;
  orderNo: string;
  orderId: number;
  action: number;
  heldAmount: number;
}

export interface HeldOpenOrdersResponseModel {
  orders: HeldOpenOrderModel[];
  openOrdersHoldAmount: number;
}

export class HeldOpenOrder {
  tickerCode: string;
  orderNo: string;
  orderId: number;
  action: number;
  heldAmount: number;

  constructor(model: HeldOpenOrderModel) {
    this.tickerCode = model.tickerCode;
    this.orderNo = model.orderNo;
    this.orderId = model.orderId;
    this.action = model.action;
    this.heldAmount = model.heldAmount;
  }
}

export class HeldOpenOrders {
  orders: HeldOpenOrder[];
  openOrdersHoldAmount: number;

  constructor(model: HeldOpenOrdersResponseModel) {
    this.orders = model?.orders ? model.orders.map((o) => new HeldOpenOrder(o)) : [];
    this.openOrdersHoldAmount = model?.openOrdersHoldAmount ?? 0;
  }
}
